import { Navigate, createFileRoute, useParams } from '@tanstack/react-router';

import { CreateAsset } from '@/features/AssetCollection/CreateAsset/CreateAsset';
import { useEditAssetRouteGuard } from '@/features/AssetCollection/CreateAsset/useEditAssetRouteGuard';

function EditAssetRoute() {
    const { collectionId, assetId, projectId } = useParams({
        strict: false,
    }) as {
        collectionId: string;
        assetId: string;
        projectId: string;
    };
    const { redirectTo } = useEditAssetRouteGuard({
        assetId,
        projectId,
        collectionId,
    });

    if (redirectTo) {
        return <Navigate to={redirectTo.to} params={redirectTo.params} />;
    }

    return <CreateAsset />;
}

export const Route = createFileRoute(
    '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/edit-asset',
)({
    component: EditAssetRoute,
});
